export const applianceConstants = {
  DETAIL_REQUEST: 'APPLIANCE_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'APPLIANCE_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'APPLIANCE_DETAIL_FAILURE'
};
